// Import ColorGuide
// import * as ColorGuide from '../cssGuides/colorGuide';

// Import Logos
import Logo from '../assets/Logo/AP2.svg';
import SquareLogo from '../assets/OGData/AP_logo.jpg';

export default {
  // Firma Domaine
  Domaine: 'arkitektpension.dk',
  Origin: 'https://classic.arkitektpension.dk',
  logoutUrl: 'https://classic.arkitektpension.dk/ap/log-ind/din-pension/Log-ud',
  // Primary Web Color
  PrimaryColor: '#518eaa',
  PrimaryHover: '#4291b8',
  PrimaryVisited: '#4f4586',
  // Logos
  DesktopLogo: Logo,
  MobileLogo: Logo,
  SquareLogo,
  // Logo Sizes
  LogoSizeMobile: '25px',
  LogoSizeTabletP: '25px',
  LogoSizeTabletL: '30px',
  LogoSizeDesktop: '40px',
  // Logo left padding
  LogoLeftMobile: '10px',
  LogoLeftTabletP: '25px',
  LogoLeftTabletL: '25px',
  LogoLeftDesktop: '30px',
  // Logo container size
  LogoContainerSize: '256px',
  // MainMenu ON/OFF
  MainMenuSeperator: true,
  // Footer Links
  FooterLinks: true,
  // Button Name (Login)
  BtnName: 'Log ind',
  // Root folder
  StartUrl: '/medlem',
  // Mobile Table  Collapse
  MobileTable: '#bbdced',
  // Search enigne key
  EngineKey: '7LmjeoNNAGbgmPnrHm8h',
};
